import { render } from "./AppHeaderDropdownAccnt.vue?vue&type=template&id=2ce9f0e0&scoped=true"
import script from "./AppHeaderDropdownAccnt.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdownAccnt.vue?vue&type=script&lang=js"

import "./AppHeaderDropdownAccnt.vue?vue&type=style&index=0&id=2ce9f0e0&scoped=true&lang=css"

import exportComponent from "C:\\GDAR_py\\apiPOS\\posWebUI\\pos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce9f0e0"]])

export default __exports__